export function sliceDate(value) {
  if (value === undefined) {
    return ''
  }

  return `${value.slice(10, 16)}`
}

export function wordDate(value) {
  if (!value) {
    return ''
  }
  let ourDate = `${value.slice(8, 10)}`
  let newDate = new Date().toISOString().slice(8, 10)
  let yesterday = new Date().toISOString().slice(8, 10) - 1
  let tomorrow = new Date().toISOString().slice(8, 10) + 1

  if (ourDate === newDate) {
    return 'Сегодня'
  }
  if (ourDate === yesterday) {
    return 'Вчера'
  }
  if (ourDate === tomorrow) {
    return 'Завтра'
  }

  return `${value.slice(0, 10)}`
}
